const temporalFrequencies = {
  id: "temporalFrequencies",
  label: "Temporal Frequencies",
  endpoint: "temporal_frequencies",
  columnConfig: [
    {
      field: "name",
      headerName: "Temporal Frequency",
      width: 250,
      description: "Temporal Frequency",
      editable: true,
    },
  ],
  hiddenColumns: ["id"],
  chipConfig: {},
  tagConfig: {},
};

export default temporalFrequencies;
